import { LoadablePaint } from '@confluence/loadable';

export const SpaceManagerLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceManagerContainer" */ './SpaceManager'))
			.SpaceManager,
});
